import { useRef } from 'react';

import { Tooltip } from 'src/components/tooltip';
import { useTrimmedElementCheck } from 'src/hooks/use-trimmed-element-check';

import './breadcrumbs.scss';

export interface BreadcrumbsProps {
  unitTitle?: string;
  lessonNumber?: string;
}

const Breadcrumbs = ({ unitTitle, lessonNumber }: BreadcrumbsProps) => {
  const breadcrumbsRef = useRef<HTMLDivElement>(null);

  const isBreadcrumbsTrimmed = useTrimmedElementCheck(breadcrumbsRef);

  const getBreadcrumbItem = (title?: string) => {
    if (!title) return;

    return <span className="breadcrumbs__item">{title}</span>;
  };

  const getTooltipTitle = () => {
    if (!unitTitle && !lessonNumber) return '';

    if (unitTitle && !lessonNumber) return unitTitle;

    if (!unitTitle && lessonNumber) return lessonNumber;

    return `${unitTitle} > ${lessonNumber}`;
  };

  return (
    <Tooltip
      title={getTooltipTitle()}
      classNames={{ tooltip: 'sh-mobile-tooltip-bottom-center' }}
      suppress={!isBreadcrumbsTrimmed}
    >
      <div
        ref={breadcrumbsRef}
        className="breadcrumbs"
        tabIndex={isBreadcrumbsTrimmed ? 0 : -1}
      >
        {getBreadcrumbItem(unitTitle)}
        {unitTitle && lessonNumber && (
          <span className="breadcrumbs__divider">{`>`}</span>
        )}
        {getBreadcrumbItem(lessonNumber)}
      </div>
    </Tooltip>
  );
};

export default Breadcrumbs;
